export const ontologyTypes = [
  { key: 'person', label: '人物', count: 238736 },
  { key: 'org', label: '机构', count: 39372 },
  { key: 'location', label: '地点', count: 18540 },
  { key: 'event', label: '事件', count: 29379 }
]

export const attributeOptions = {
  person: [
    { label: '姓名', value: 'name' },
    { label: '性别', value: 'gender' },
    { label: '生卒年', value: 'lifespan' }
  ],
  org: [
    { label: '名称', value: 'name' },
    { label: '行业', value: 'industry' },
    { label: '地址', value: 'address' }
  ],
  location: [
    { label: '名称', value: 'name' },
    { label: '区域', value: 'region' }
  ],
  event: [
    { label: '名称', value: 'name' },
    { label: '时间', value: 'time' }
  ]
}

export const knowledgeResults = [
  {
    id: 1,
    type: 'person',
    typeLabel: '人物',
    title: '杨宗濂',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '性别', value: '男' },
      { label: '时代', value: '清末民初' },
      { label: '生卒', value: '1842-1914' }
    ],
    intro: '杨宗濂，字润甫，江苏无锡人。晚清实业家，参与创办多家近代企业，推动民族工商业发展，是江南地区重要的工商文化代表人物之一。'
  },
  {
    id: 2,
    type: 'org',
    typeLabel: '机构',
    title: '继昌隆缫丝厂',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '行业', value: '纺织业' },
      { label: '地址', value: '广东佛山' },
      { label: '创办', value: '1872年' }
    ],
    intro: '继昌隆缫丝厂由陈启创办于1872年，是中国近代民族资本主义缫丝工业的先驱，标志着民族工商业由传统手工业向机器生产转型的重要节点。'
  },
  {
    id: 3,
    type: 'location',
    typeLabel: '地点',
    title: '上海外滩',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '区域', value: '上海市黄浦区' },
      { label: '类型', value: '工商区' },
      { label: '时期', value: '1860-1956' }
    ],
    intro: '上海外滩是近代中国民族工商业的重要发祥地之一，汇聚了大量银行、洋行与民族企业总部，见证了民族资本与外商资本博弈发展的历史进程。'
  },
  {
    id: 4,
    type: 'event',
    typeLabel: '事件',
    title: '洋务运动',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '时间', value: '1860-1895' },
      { label: '范围', value: '全国' },
      { label: '性质', value: '近代化开端' }
    ],
    intro: '洋务运动是晚清时期以"自强""求富"为口号的学习西方科学技术与军事工业的变革运动，江南制造总局、轮船招商局等一批近代企业相继设立。'
  },
  {
    id: 5,
    type: 'person',
    typeLabel: '人物',
    title: '张謇',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '性别', value: '男' },
      { label: '时代', value: '清末民初' },
      { label: '生卒', value: '1853-1926' }
    ],
    intro: '张謇，字季直，江苏南通人。清末状元，著名实业家，创办大生纱厂等一批民族企业，提出"实业救国"主张，对中国近代民族工商业发展影响深远。'
  },
  {
    id: 6,
    type: 'org',
    typeLabel: '机构',
    title: '江南制造总局',
    image: 'https://images.unsplash.com/photo-1565008576549-57569a49371d?w=160&h=160&fit=crop&grayscale',
    meta: [
      { label: '行业', value: '机械制造' },
      { label: '地址', value: '上海' },
      { label: '创办', value: '1865年' }
    ],
    intro: '江南制造总局由李鸿章主持创办，是洋务运动中规模最大的军事工业企业，兼营民用机械制造，对中国近代工业体系的建立具有奠基性意义。'
  }
]
